// Minimal router. Only the routes that Wildcatz kiosks actually load are
// wired up here. Adding more sports is just an import + a Route line.
import React, { Suspense, lazy } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';

// Phase 1 (2026-06-02): only TVDisplay (which handles cricket via inline
// rendering and routes to the sport-specific TVs for other sports). When
// kiosks point at this app, the cricket Court 1/2/3 TVs are immediately
// covered. Other sports added in Phase 2 as needed.
const TVDisplay = lazy(() => import('./pages/TVDisplay'));
// 2026-06-04 fix: TVDisplay reads :matchId from useParams, so routing the
// /court/:courtNum path straight at it left matchId undefined and the kiosk
// rendered the TODAY'S SCHEDULE fallback even when a match was live. CourtTV
// picks the active match for the court and routes to TVDisplay with the
// correct matchId.
const CourtTV = lazy(() => import('./pages/CourtTV'));

function LoadingFallback() {
  return (
    <div style={{
      position: 'fixed', inset: 0,
      display: 'flex', alignItems: 'center', justifyContent: 'center',
      background: '#0a0a0a', color: '#fff',
      fontFamily: 'system-ui, -apple-system, sans-serif',
      fontSize: '1.25rem', letterSpacing: '0.05em', opacity: 0.85,
    }}>
      Loading scoreboard…
    </div>
  );
}

export default function App() {
  return (
    <Suspense fallback={<LoadingFallback />}>
      <Routes>
        {/* Primary kiosk route. courtNum is 1/2/3 etc. */}
        <Route path="/:venueSlug/tv/court/:courtNum" element={<CourtTV />} />
        {/* Per-match URL — CourtTV navigates here with ?courtReturn=N once
            it picks the active cricket match for the court. */}
        <Route path="/:venueSlug/tv/:matchId" element={<TVDisplay />} />
        {/* Backwards-compat: /:venueSlug/tv with ?court=N query string. */}
        <Route path="/:venueSlug/tv" element={<TVDisplay />} />
        {/* Root → redirect to Wildcatz Court 1 as sensible default. */}
        <Route path="/" element={<Navigate to="/wildcatz/tv/court/1" replace />} />
        {/* Anything else → friendly message. */}
        <Route path="*" element={
          <div style={{
            position:'fixed', inset:0, display:'flex', alignItems:'center', justifyContent:'center',
            color:'#fff', background:'#0a0a0a', fontFamily:'system-ui',
            fontSize:'1.5rem', textAlign:'center', padding:'2rem',
          }}>
            <div>
              <div style={{ fontWeight:900, marginBottom:12 }}>WISA TV</div>
              <div style={{ opacity:0.7, fontSize:'1rem' }}>
                Configure your kiosk Start URL to:<br/>
                <code style={{ background:'#222', padding:'4px 10px', borderRadius:6, marginTop:8, display:'inline-block' }}>
                  https://tv.all4indoor.com/&lt;venue&gt;/tv/court/&lt;n&gt;
                </code>
              </div>
            </div>
          </div>
        } />
      </Routes>
    </Suspense>
  );
}
